import styled from 'styled-components';
import appTheme from '../../../../themes/Theme';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';

export const StyleWrapper = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
`;

export const StyledLabel = styled.span`
  font-weight: 500;
  color: ${props => props.active ? "rgb(37, 194, 160)" : appTheme.textColor};
  :hover {
    color: rgb(37, 194, 160);
    cursor: pointer;
  }
`;

export const StyledSelect = styled(Select)`
  && {
    color: ${appTheme.textColor};
    font-weight: 500;
    ::before {
      border-bottom: none;
    }
    ::after {
      border-bottom: none;
    }
    :hover:before {
      border-bottom: none !important;
    }
  }
  & .MuiSelect-select.MuiSelect-select {
    padding-right: 4px;
  }
  & .MuiSelect-select:focus {
    background-color: ${appTheme.navbarColor};
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    font-weight: 500;
  }
`;

export const StyledDropDownIcon = styled(ArrowDropDownOutlinedIcon)`
  && {
    color: ${appTheme.textColor};
  }
`;
